import { View } from "@react-pdf/renderer";
import type { FC } from "react";
import type { ReportBlock } from "@/types/blocks";
import { PdfMdText } from "./PdfMdText";
import { PdfKpiCard } from "./PdfKpiCard";
import { PdfTable } from "./PdfTable";
import { PdfChart } from "./PdfChart";
import styles from "./pdfStyles";

interface PdfBlockRendererProps {
  blocks: ReportBlock[];
  chartImages: Map<number, string>;
}

export const PdfBlockRenderer: FC<PdfBlockRendererProps> = ({ blocks, chartImages }) => {
  let chartIndex = 0;

  return (
    <View style={styles.blocksContainer}>
      {blocks.map((block, i) => {
        switch (block.type) {
          case "md_text":
            return (
              <View key={i} minPresenceAhead={40}>
                <PdfMdText content={block.content} />
              </View>
            );
          case "kpi_card":
            return (
              <View key={i} wrap={false} minPresenceAhead={120}>
                <PdfKpiCard block={block} />
              </View>
            );
          case "table":
            return (
              <View key={i} minPresenceAhead={110}>
                <PdfTable block={block} />
              </View>
            );
          case "line_chart":
          case "bar_chart":
          case "pie_chart": {
            const imgIdx = chartIndex++;
            const dataUrl = chartImages.get(imgIdx);
            if (!dataUrl) return null;
            return (
              <View key={i} wrap={false} minPresenceAhead={120}>
                <PdfChart title={block.title} imageDataUrl={dataUrl} />
              </View>
            );
          }
          default:
            return null;
        }
      })}
    </View>
  );
};
